<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <div v-if="localStep.action == 'self/SEND EMAIL'">
      <el-button
        :loading="!companyAllTemplateFields"
        class="email-config-button"
        @click="openEmailConfig()"
      >
        <i style="color: #409eff" class="el-icon-setting">configure email</i>
      </el-button>
      <el-checkbox v-model="localStep.isUpdateEmailBody">
        Update email body if template changes
      </el-checkbox>
      <el-select
        v-if="localStep.isUpdateEmailBody"
        v-model="localStep.selectedNotificationTemplate"
        placeholder="Choose above configured template"
      >
        <el-option
          v-for="item in notificationTemplates"
          :key="item._id"
          :label="item.name"
          :value="item._id"
        ></el-option>
      </el-select>
    </div>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :title="'Notify'"
      :visible="configureEmailTemplate"
      :isShowFooter="false"
      :containerWidth="'52%'"
      @before-close="configureEmailTemplateDialog"
    >
      <EmailConfig
        v-loading="emailConfigLoading"
        :element-loading-text="loadingText"
        :currentEntity="currentEntity"
        :isSendIndividual="true"
        :isAutomation="true"
        :keyValue="this.emailConfigKey"
        :paramsContent="paramsData"
        :allFields="getUserEntities(getFieldsByType(['ENTITY'], allFieldsWithDataTable))"
        v-on:closeNotificationDialog="closeSendNotificationDialog"
        :companyAllTemplateFields="companyAllTemplateFields"
        :allEntities="allEntities"
        class="popUp-content"
      ></EmailConfig>
    </dialog-component>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import { mapGetters } from 'vuex';
  export default {
    name: 'SendEmailAction',
    props: {
      step: Object,
      companyAllTemplateFields: Object,
      allEntities: Array,
      currentEntity: Object,
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    components: {
      EmailConfig: () => import('@/components/notifications/emailConfig.vue'),
    },
    data() {
      return {
        notificationTemplates: [],
        emailConfigKey: '',
        paramsData: {},
        configureEmailTemplate: false,
        emailConfigLoading: false,
        loadingText: 'loading Data..',
        allFieldsWithDataTable: [],
        email_object: {},
      };
    },
    mounted() {
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
    },
    computed: {
      ...mapGetters('s3FileUpload', ['getFileUploadData']),
    },
    methods: {
      async openEmailConfig() {
        this.emailConfigKey = (Math.random() + 1).toString(36).substring(7);
        if (this.localStep?.email_object) {
          this.paramsData = { ...this.localStep.email_object };
        } else {
          this.paramsData = {};
        }
        this.configureEmailTemplate = true;
      },
      configureEmailTemplateDialog() {
        this.configureEmailTemplate = false;
      },
      async closeSendNotificationDialog(data) {
        this.emailConfigLoading = true;
        if (data.attachments && data.attachments?.length) {
          this.loadingText = 'Uploading Files';
          let files = data.attachments.map((e) => {
            return {
              name: e.filename,
              mimetype: e.type,
              data: e.content,
              size: e.size,
            };
          });
          let params = {
            files: files,
            path: 'email-attachments',
          };
          await this.$store.dispatch('s3FileUpload/uploadMultipleBase64Files', params);
          if (this.getFileUploadData && this.getFileUploadData.length) {
            data.attachments = this.getFileUploadData;
          }
        }
        this.loadingText = 'Saving Data';
        this.email_object = {
          ...data,
        };
        this.configureEmailTemplate = false;
        this.emailConfigLoading = false;
        this.$set(this.localStep, 'email_object', this.email_object);
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
  }

  .email-config-button {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 14px;
    padding: 4px 12px;
    border-radius: 6px;
  }

  .el-checkbox {
    font-size: 13px;
    margin-top: 0.5rem;
  }

  .el-select {
    width: 100%;
    font-size: 13px;
    margin-top: 0.25rem;
    border-radius: 6px;
  }

  .el-select .el-input__inner {
    padding: 0.35rem 0.75rem;
  }

  .el-option:hover {
    background-color: #eff6ff;
  }

  .popUp-content {
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 8px;
  }

  .dialog-component .el-dialog__header {
    font-weight: 600;
    font-size: 16px;
    color: #111827;
  }

  .dialog-component .el-dialog__body {
    padding: 1rem 1.25rem;
  }

  .dialog-component .el-dialog__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 12px 0;
  }

  i.el-icon-setting {
    font-size: 14px;
  }

  .v-loading-text {
    font-size: 13px;
    color: #6b7280;
  }
</style>
